import React, { useState } from "react";

function Register({ goToLogin }) {
  const [form, setForm] = useState({
    name: "",
    shopName: "",
    state: "",
    loginId: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRegister = () => {
    if (
      !form.name ||
      !form.shopName ||
      !form.state ||
      !form.loginId ||
      !form.password ||
      !form.mobile
    ) {
      setError("Please fill all required fields");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (form.mobile.length !== 10) {
      setError("Enter valid 10 digit mobile number");
      return;
    }
    setLoading(true);
    fetch("/api/auth/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: form.name,
        shopName: form.shopName,
        state: form.state,
        loginId: form.loginId,
        password: form.password,
        mobile: form.mobile,
        email: form.email,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        setLoading(false);
        if (data.userId) {
          setSuccess(true);
          setError("");
        } else {
          setError(data.message || "Registration failed");
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Server error — please try again");
      });
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    background: "#C2B067",
    border: "1px solid #856A00",
    borderRadius: "6px",
    color: "#403301",
    fontSize: "14px",
    fontFamily: "Arial",
    boxSizing: "border-box",
  };
  const labelStyle = {
    fontSize: "12px",
    color: "#403301",
    display: "block",
    marginBottom: "4px",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8f9fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Arial",
      }}
    >
      <div style={{ width: "420px" }}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img
            src="https://botmotautomations.com/wp-content/uploads/2025/06/cropped-cropped-Logo-1-1-50x38.png"
            alt="BotMot Logo"
            style={{ width: "60px", marginBottom: "12px" }}
          />
          <div
            style={{ fontSize: "24px", fontWeight: "bold", color: "#856A00" }}
          >
            SonaCRM
          </div>
          <div style={{ fontSize: "12px", color: "#928243", marginTop: "4px" }}>
            by BotMot Automations
          </div>
        </div>

        {/* Card */}
        <div
          style={{
            background: "#928243",
            border: "1px solid #856A00",
            borderRadius: "12px",
            padding: "28px",
          }}
        >
          <h3
            style={{ margin: "0 0 20px 0", color: "#403301", fontSize: "16px" }}
          >
            Create your account
          </h3>

          {success ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <div style={{ fontSize: "40px", marginBottom: "12px" }}>✅</div>
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "#403301",
                  marginBottom: "8px",
                }}
              >
                Registration Submitted!
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "#403301",
                  marginBottom: "20px",
                }}
              >
                Your account is pending admin approval. You will be notified
                once approved.
              </div>
              <button
                onClick={goToLogin}
                style={{
                  background: "#856A00",
                  color: "gold",
                  border: "none",
                  padding: "10px 24px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Go to Login
              </button>
            </div>
          ) : (
            <>
              {error && (
                <div
                  style={{
                    background: "#fff0f0",
                    border: "1px solid #ef4444",
                    borderRadius: "6px",
                    padding: "10px 12px",
                    marginBottom: "16px",
                    fontSize: "13px",
                    color: "#ef4444",
                  }}
                >
                  {error}
                </div>
              )}

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "12px",
                  marginBottom: "12px",
                }}
              >
                <div>
                  <label style={labelStyle}>Full Name *</label>
                  <input
                    placeholder="Abhijeet"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Shop Name *</label>
                  <input
                    placeholder="SonaJewels"
                    value={form.shopName}
                    onChange={(e) =>
                      setForm({ ...form, shopName: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Mobile Number *</label>
                  <input
                    placeholder="98XXXXXXXX"
                    maxLength="10"
                    value={form.mobile}
                    onChange={(e) =>
                      setForm({ ...form, mobile: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Email</label>
                  <input
                    placeholder="admin@shop.com"
                    value={form.email}
                    onChange={(e) =>
                      setForm({ ...form, email: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label style={labelStyle}>State *</label>
                  <select
                    value={form.state}
                    onChange={(e) =>
                      setForm({ ...form, state: e.target.value })
                    }
                    style={inputStyle}
                  >
                    <option value="">Select State</option>
                    <option>Andhra Pradesh</option>
                    <option>Arunachal Pradesh</option>
                    <option>Assam</option>
                    <option>Bihar</option>
                    <option>Chhattisgarh</option>
                    <option>Goa</option>
                    <option>Gujarat</option>
                    <option>Haryana</option>
                    <option>Himachal Pradesh</option>
                    <option>Jharkhand</option>
                    <option>Karnataka</option>
                    <option>Kerala</option>
                    <option>Madhya Pradesh</option>
                    <option>Maharashtra</option>
                    <option>Manipur</option>
                    <option>Meghalaya</option>
                    <option>Mizoram</option>
                    <option>Nagaland</option>
                    <option>Odisha</option>
                    <option>Punjab</option>
                    <option>Rajasthan</option>
                    <option>Sikkim</option>
                    <option>Tamil Nadu</option>
                    <option>Telangana</option>
                    <option>Tripura</option>
                    <option>Uttar Pradesh</option>
                    <option>Uttarakhand</option>
                    <option>West Bengal</option>
                    <option>Delhi</option>
                    <option>Jammu & Kashmir</option>
                    <option>Ladakh</option>
                  </select>
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label style={labelStyle}>Login ID *</label>
                  <input
                    placeholder="Choose a unique login ID"
                    value={form.loginId}
                    onChange={(e) =>
                      setForm({ ...form, loginId: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Password *</label>
                  <input
                    type="password"
                    placeholder="Min 6 characters"
                    value={form.password}
                    onChange={(e) =>
                      setForm({ ...form, password: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Confirm Password *</label>
                  <input
                    type="password"
                    placeholder="Re-enter password"
                    value={form.confirmPassword}
                    onChange={(e) =>
                      setForm({ ...form, confirmPassword: e.target.value })
                    }
                    style={inputStyle}
                  />
                </div>
              </div>

              <button
                onClick={handleRegister}
                disabled={loading}
                style={{
                  width: "100%",
                  background: "#856A00",
                  color: "gold",
                  border: "none",
                  padding: "11px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
              >
                {loading ? "Registering..." : "Register"}
              </button>

              <div
                style={{
                  textAlign: "center",
                  marginTop: "16px",
                  fontSize: "13px",
                  color: "#403301",
                }}
              >
                Already have an account?{" "}
                <span
                  onClick={goToLogin}
                  style={{
                    color: "#856A00",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Login here
                </span>
              </div>
            </>
          )}
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "20px",
            fontSize: "11px",
            color: "#928243",
          }}
        >
          Powered by BotMot Automations · Bhutani Corp
        </div>
      </div>
    </div>
  );
}

export default Register;
